<template>
    <div class="fSize emptyDiv">
        <van-field v-model="data.name" name="name" :label="'姓' + '\u3000\u3000' + '名'" placeholder="请输入姓名" required />
        <van-field v-model="data.id_no" name="id_no" label="证件号码" maxlength="18" placeholder="请输入身份证号码" required />
        <van-field v-model="data.tel" type="tel" name="tel" label="手机号码" maxlength="11" placeholder="请输入手机号码"
            required />
        <van-field v-model="data.code" type="text" name="code" required center clearable maxlength="6"
        :label="'验' + '\u3000' + '证'+'\u3000' +'码'" placeholder="请输入图形验证码">
            <template #button>
                <img :src="captchaSrc" @click="refreshCaptcha" style="height: 32px; cursor: pointer;">
            </template>
        </van-field>

        <van-cell class="buttonFixed" safe-area-inset-bottom>
            <van-button size="normal" round block type="info" :disabled="submitShow" :loading="submitShow"
                :loading-text="submitText" @click="submitFun">{{ submitText }}
            </van-button>
        </van-cell>
    </div>
</template>
<script>
import { Field, Button, Toast, Cell } from 'vant';
import { getCode } from '@/api/common';
import { addUser } from '@/api/user';

export default {
    components: {
        [Field.name]: Field, [Button.name]: Button, [Toast.name]: Toast, [Cell.name]: Cell
    },
    data() {
        return {
            data: {             //添加页面数据
                name: "",
                id_no: null,
                tel: null,
                code: null,
                captchaKey:null,
                captchaSrc: ""
            },
            //验证码
            codeShow: false,
            codeText: "发送验证码",
            timer: null,
            //提交按钮
            submitShow: false,
            submitText: "提交"
        }
    },
    created() {
        this.refreshCaptcha();
    },
    methods: {
        refreshCaptcha() {
            this.data.captchaKey = Date.now().toString(); // 生成唯一 key
            let openId=sessionStorage.getItem("openid");
            this.captchaSrc = process.env.VUE_APP_BASE_API + `/business/captcha?openId=${openId}&key=${this.data.captchaKey}`
            // 访问后端验证码接口
        },
        //添加页面提交
        submitFun() {
            const that = this;
            //这里进行数据校验
            if (that.data.name == null || that.data.name === "") {
                Toast("【姓名】不能为空...");
                return false;
            }
            if (that.data.id_no == null || that.data.id_no === "" || !(/^\d{17}([0-9]|X)$/.test(that.data.id_no))) {
                Toast("【身份证号码】不能为空或格式错误...");
                return false;
            }
            if (that.data.id_no.length !== 18) {
                Toast("【身份证号码】长度为18位...");
                return false;
            }
            if (that.data.tel == null || that.data.tel === "" || !(/^1[3456789]\d{9}$/.test(that.data.tel))) {
                Toast("【手机号码】不能为空或格式错误...");
                return false;
            }
            if (that.data.tel.length !== 11) {
                Toast("【手机号码】长度为11位...");
                return false;
            }
            if (that.data.code == null || that.data.code === "") {
                Toast("【验证码】不能为空...");
                return false;
            }
            if (that.data.code.length !== 4) {
                Toast("【验证码】长度为4位...");
                return false;
            }
            //深度拷贝,数据组装
            let data = JSON.parse(JSON.stringify(that.data));
            data.phoneNumber = data.tel;
            delete data.tel;
            data.cardNumber = data.id_no;
            delete data.id_no;
            data.openId = sessionStorage.getItem("openid");
            //按钮相关操作
            that.submitText = "提交中...";
            that.submitShow = true;
            //请求方法
            addUser(data).then(resp => {
                if (resp.code === 200) {
                    Toast({
                        type: 'success',
                        message: '添加成功...',
                        duration: 2000,
                        onOpened: function () {
                            sessionStorage.setItem("userIsBang", "yes");
                            //访问调用方方法
                            that.$emit('fatherMethod');
                        }
                    })
                } else {
                    Toast({
                        type: 'fail',
                        message: resp.msg
                    })
                }
                setTimeout(function () {
                    that.submitText = "提交";
                    that.submitShow = false;
                }, 2000)
            }).catch(err => {
                console.log(err);
            })
        }
    }
}
</script>
<style scoped>
.emptyDiv {
    height: 5.1rem;
}
</style>
